const ADVERT_FAVORITE_ADD_URL = '/advert/favorite/action/add';
const ADVERT_FAVORITE_REMOVE_URL = '/advert/favorite/action/remove';
const ADVERT_FAVORITE_INIT_URL = '/advert/favorite/list/init';

const API_ADVERT_FAVORITE_NAME = 'apiAdvertFavorite';
const REDUCER_ADVERT_FAVORITE_NAME = 'advertFavorite';

export {
  ADVERT_FAVORITE_ADD_URL,
  ADVERT_FAVORITE_REMOVE_URL,
  ADVERT_FAVORITE_INIT_URL,

  API_ADVERT_FAVORITE_NAME,
  REDUCER_ADVERT_FAVORITE_NAME,
};
